  function initLoadMore(){
  const loadMoreBtn = document.getElementById("load-more-btn");
  const productGrid = document.getElementById("product-grid");
  const productCount = document.getElementById("product-count");

  if (!loadMoreBtn || !productGrid) return;

  const totalProducts = parseInt(productGrid.getAttribute("total-product"));
  const BATCH_SIZE = parseInt(productGrid.getAttribute("batch-size"));

  let isFetching = false; 

function updateCount() {
  const allProducts = productGrid.querySelectorAll("li");
  const visible = [...allProducts].filter(el => el.style.display !== "none").length;

  productCount.innerText = `Showing ${visible} of ${totalProducts} products`;

  
  if (visible >= totalProducts) {
    loadMoreBtn.style.display = "none";
  } else {
    loadMoreBtn.style.display = "block"; 
  }

}

  function showNextBatch() {
    const hiddenProducts = [...productGrid.querySelectorAll("li")]
      .filter(el => el.style.display === "none");

    hiddenProducts.slice(0, BATCH_SIZE).forEach(el => {
      el.style.display = "";
    });
  }

  function fetchProducts(url) {
    if (isFetching) return;
    isFetching = true;

    fetch(url)
      .then(res => res.text())
      .then(html => {

        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");

        const newProducts = doc.querySelectorAll("#product-grid li");
        const newBtn = doc.querySelector("#load-more-btn");

        newProducts.forEach(el => {
          el.style.display = "none"; 
          productGrid.appendChild(el);
        });

        if (newBtn) {
          loadMoreBtn.setAttribute(
            "data-next-url",
            newBtn.getAttribute("data-next-url")
          );
        } else {
          loadMoreBtn.removeAttribute("data-next-url");
        }

        isFetching = false;
      })
      .catch(err => {
        console.log(err);
        isFetching = false;
      });
  }


  function prefetchIfNeeded() {
    const hiddenProducts = [...productGrid.querySelectorAll("li")]
      .filter(el => el.style.display === "none");

    const nextUrl = loadMoreBtn.getAttribute("data-next-url");

    if (hiddenProducts.length <= BATCH_SIZE && nextUrl) {
      fetchProducts(nextUrl); 
    }
  }

 
  updateCount();
  prefetchIfNeeded();

  loadMoreBtn.addEventListener("click", function () {

 this.classList.add("loading");
  this.querySelector(".btn-text").innerText = "Loading...";
  this.disabled = true;
  showNextBatch();
  updateCount();
  prefetchIfNeeded();
  setTimeout(() => {
    this.classList.remove("loading");
    this.querySelector(".btn-text").innerText = "Load More";
    this.disabled = false;
  }, 1000); 
  });
}
document.addEventListener("DOMContentLoaded", () => {
  initLoadMore();
});